import { render, staticRenderFns } from "./NewBuy.vue?vue&type=template&id=a2ac90d8&scoped=true"
import script from "./NewBuy.vue?vue&type=script&lang=js"
export * from "./NewBuy.vue?vue&type=script&lang=js"
import style0 from "./NewBuy.vue?vue&type=style&index=0&id=a2ac90d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ac90d8",
  null
  
)

export default component.exports